export const fetch_teams = () => (dispatch) => {
    var url = global.config.server_path + 'user/fetch_teams';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}


export const upload_brand_file = (name, file_type, file) => dispatch => {
  	var form_data = new FormData()
  	form_data.append('name', name);
  	form_data.append('file_type', file_type);
  	form_data.append('file', file, file.name);
  	var url = global.config.server_path + 'user/upload_brand_file';
	return fetch(url, {method: 'POST', 'credentials': 'include', body: form_data})
};


export const update_brand_data = brand_kit => (dispatch) => {
    var url = global.config.server_path + 'user/update_brand_data';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({brand_kit})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}


export const fetch_color_palettes = (category, limit, page) => (dispatch) => {
    var url = global.config.server_path + 'design_resource/get_color_palettes';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({category, limit, page})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}


export const fetch_display_color_palettes = brand_kit => (dispatch) => {
    var url = global.config.server_path + 'design_resource/get_display_color_palettes';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}


var validate_response = (response) => response.response_code === 1 ? Promise.resolve(response) : Promise.reject(response)